<app-page-header
    [title]="environment.isCodalt ? 'Planning Codalt' : 'Planning DvdS'"
    [subtitle]="environment.isCodalt ? 'Overzicht' : 'Frees- en transport'"
    [print]="print"
    [forceMobileMenu]="mobile"
    (selectedTeams)="selectedTeamsChange($event)"
    (headerClick)="setCenterDate()">
    <app-date-indicator
        class="gap-2"
        [print]="print"
        [singleDate]="currentDate"
        (next)="next()"
        (prev)="prev()"
        indicator>
        <ng-container filters>
            @if (!print && !mobile) {
                <app-planning-filter (selectedTeams)="selectedTeamsChange($event)" />

                <div>
                    <div class="settings">
                        <div class="trigger" [cdkMenuTriggerFor]="filterPerformer">
                            <div class="icon"><i class="fa-solid fa-chevron-down"></i></div>
                            <div class="name">{{ environment.executorName | ucFirst }}</div>
                        </div>
                    </div>
                </div>

                @if (readOnly) {
                    <div class="status-text align-self-center" [class.concept]="fcPlanningStatus.value === 'concept'">
                        @if (fcPlanningStatus.value === 'concept') {
                            <i class="fa-duotone fa-solid fa-triangle-exclamation"></i>
                        }
                        {{ fcPlanningStatus.value ?? 'laden...' }}
                    </div>
                }

                @if (!print && !readOnly) {
                    <div>
                        <div class="settings">
                            <div class="trigger" [cdkMenuTriggerFor]="fcPlanningStatus.value ? statusMenu : null">
                                <div class="icon"><i class="fa-solid fa-chevron-down"></i></div>
                                <div class="name">{{ fcPlanningStatus.value ?? 'laden...' }}</div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="settings">
                            <div class="trigger" [cdkMenuTriggerFor]="configMenu">
                                <div class="icon"><i class="fa-solid fa-chevron-down"></i></div>
                                <div class="name">Weergave</div>
                            </div>
                        </div>
                    </div>
                }
            }
        </ng-container>
    </app-date-indicator>

    <div print-pdf>
        <input
            #dateInput
            [matDatepicker]="picker"
            [value]="currentDate"
            (dateChange)="onDateSelected($event)"
            matInput
            style="border: none; width: 0px; height: 0px" />

        <button class="menu-button" (click)="openPicker()" color="primary" mat-icon-button>
            <mat-icon fontSet="fa-regular" fontIcon="fa-calendar-range" />
        </button>

        <button class="menu-button" (click)="pdf()" color="primary" mat-icon-button>
            @if (!downloadingPdf) {
                <mat-icon fontSet="fa-regular" fontIcon="fa-file-pdf" />
            }
            @if (downloadingPdf) {
                <mat-spinner />
            }
        </button>

        <mat-datepicker #picker [startAt]="currentDate" (dateChange)="onDateSelected($event)" />
    </div>

    <div menu-filters>
        <div class="w-100">
            <app-planning-filter (selectedTeams)="selectedTeamsChange($event)" />
        </div>

        <div class="w-100">
            <div>Selecteer {{ environment.executorName | ucFirst }}</div>

            <button class="w-100 text-left" [cdkMenuTriggerFor]="filterPerformer" mat-button>
                @if (fcPerformerIds.value?.length === 0) {
                    Alle {{ environment.executorName | ucFirst }}
                }
                @if (fcPerformerIds.value?.length === 1) {
                    {{ (executors | byId: fcPerformerIds.value[0])?.name }}
                }
                @if (fcPerformerIds.value?.length > 1) {
                    {{ fcPerformerIds.value.length }} {{ environment.executorName | ucFirst }} geselecteerd
                }
            </button>
        </div>

        <div class="w-100">
            <div>Status</div>

            @if (readOnly || !fcPlanningStatus.value) {
                <div class="status-text px-3" [class.concept]="fcPlanningStatus.value === 'concept'">
                    @if (fcPlanningStatus.value === 'concept') {
                        <i class="fa-duotone fa-solid fa-triangle-exclamation"></i>
                    }
                    {{ fcPlanningStatus.value ?? 'laden...' }}
                </div>
            } @else {
                <mat-radio-group class="d-block px-3" [formControl]="fcPlanningStatus">
                    @for (status of ['besloten', 'concept', 'definitief']; track status) {
                        <mat-radio-button [value]="status">
                            {{ status }}
                        </mat-radio-button>
                    }
                </mat-radio-group>
            }
        </div>

        @if (!print && !readOnly) {
            <div class="w-100">
                <div>Weergave</div>
                <span class="d-block px-3">
                    <mat-checkbox class="me-3" [formControl]="fcShowSmallMaterials">Pers/mat</mat-checkbox><br />
                    <mat-checkbox class="me-3" [formControl]="fcShowInUse">Bezetting</mat-checkbox><br />
                    <mat-checkbox [formControl]="fcShowComments">Kladblok</mat-checkbox>
                </span>
            </div>
        }
    </div>

    @if (print) {
        <div actions>PDF datum: {{ now | date: 'd MMMM yyyy HH:mm' }}</div>
    }
</app-page-header>

<div class="text-container">
    <div class="overview-and-side" [class.show-in-use]="fcShowInUse.value" cdkDropListGroup>
        <div class="overview">
            <div class="legend">
                @if (!planningForms) {
                    <div class="loading">Laden...</div>
                }
                @if (planningForms && !dayIsFixed && !hasPlanningsOnFixedDays) {
                    <div class="loading">Deze dag is nog niet vastgezet in de weekplanning</div>
                }
                @if ((dayIsFixed || hasPlanningsOnFixedDays) && planningForms?.length === 0) {
                    <div class="loading">Er zijn geen defintieve planningen voor deze dag</div>
                }
                @if (!canViewPlanning && planningForms && (dayIsFixed || hasPlanningsOnFixedDays)) {
                    <div class="loading">
                        De planning voor {{ currentDate | date: 'd MMMM yyyy' }} is nog niet vrijgegeven
                    </div>
                }
            </div>

            @for (main of planningForms; track main.mainPlanning.id) {
                @if ((dayIsFixed || hasPlanningsOnFixedDays || main.planning.is_transport) && canViewPlanning) {
                    <table
                        class="table table-center"
                        #myDropList
                        [class.table-add-row]="!print && !readOnly"
                        (cdkDropListDropped)="onDrop($event, main)"
                        cdkDropList
                        cdkDropListLockAxis="y"
                        cdkDropListOrientation="vertical">
                        <tr class="invisible">
                            @if (!readOnly && (Features.PlanningSaveSortSave | hasFeature)) {
                                <td [style.width.px]="30"></td>
                            }
                            <td [style.width.px]="200"></td>
                            <td [style.width.px]="100"></td>
                            <td [style.width.px]="100"></td>
                            <td [attr.colspan]="readOnly ? 3 : 5"></td>
                            <td [style.width.px]="150"></td>
                            <td [style.width.px]="150"></td>
                            <td colspan="2"></td>
                        </tr>
                        <tr [class.red]="!finalStatuses.includes(main.planning.status_key)">
                            @if (main.planning.is_transport) {
                                <th class="team" [attr.colspan]="readOnly ? 12 : 14">
                                    TRANSPORT
                                    <small>diversen</small>
                                </th>
                            }
                            @if (!main.planning.is_transport) {
                                <th class="project-id" [attr.colspan]="readOnly ? 1 : 2">
                                    {{ main.planning.afas_project_id }}
                                </th>
                                @if (main.hasSets || (!main.planning.performer && !main.planning.asphalt_performer)) {
                                    <th
                                        class="team"
                                        [attr.colspan]="readOnly ? 4 : 5"
                                        (dblclick)="openPlanning(main.planning, $event)">
                                        {{ EntityTypeMap.get(main.mainPlanning.entitytype?.key)?.name }}
                                        {{ main.mainPlanning?.entity?.name }}
                                        <small
                                            >{{ (executors | byId: main.planning.asphalt_performer)?.name }} /
                                            {{ (executors | byId: main.planning.performer)?.name }}</small
                                        >
                                    </th>
                                }
                                @if (!main.hasSets && (main.planning.performer || main.planning.asphalt_performer)) {
                                    <th
                                        [attr.colspan]="readOnly ? 4 : 5"
                                        (dblclick)="openPlanning(main.planning, $event)">
                                        {{ (executors | byId: main.planning.performer)?.name }}
                                        <small>{{ (executors | byId: main.planning.asphalt_performer)?.name }}</small>
                                    </th>
                                }
                                @if (main.hasSets || true) {
                                    <th>
                                        {{ main.mainPlanning?.begindate | date: 'EEE HH:mm' }}
                                    </th>
                                }
                                @if (main.hasSets || true) {
                                    <th>
                                        {{ main.mainPlanning?.enddate | date: 'HH:mm' }}
                                    </th>
                                }
                                <th
                                    class="main-comment"
                                    [attr.colspan]="readOnly ? 4 : 5"
                                    [matTooltip]="main.planning.description">
                                    {{ main.planning.description }}
                                </th>
                            }
                            @if ((main.planning.is_transport || fcShowSmallMaterials.value) && !readOnly) {
                                <th width="300"></th>
                            }
                        </tr>
                        @if (finalStatuses.includes(main.planning.status_key)) {
                            <tr>
                                @if (!readOnly) {
                                    <th [style.width.px]="50" colspan="1"></th>
                                }
                                <th [style.width.px]="300" colspan="1">Chauffeur</th>
                                <th [style.width.px]="150" colspan="2">Materieel</th>
                                <th [style.width.px]="100">Auto</th>
                                <th [style.width.px]="100">Dieplader</th>
                                <th [style.width.px]="100">Aanvang</th>
                                <th [style.width.px]="100">Tot</th>
                                @if (!readOnly) {
                                    <th [style.width.px]="40">Start</th>
                                }
                                <th [style.width.px]="300">Van</th>
                                <th [style.width.px]="300">Naar</th>
                                @if (!readOnly) {
                                    <th [style.width.px]="40">Stop</th>
                                }
                                <th [style.min-width.px]="300">Werkzaamheden</th>
                                <th [style.min-width.px]="100">{{ environment.executorName | ucFirst }}</th>
                                @if (main.planning.is_transport) {
                                    <th [style.width.px]="200">Project</th>
                                }
                                @if (!main.planning.is_transport && this.fcShowSmallMaterials.value) {
                                    <td
                                        class="employees-equipment"
                                        [style.min-width.px]="250"
                                        [attr.rowspan]="main.entities | entitiesRows">
                                        <div>
                                            <div class="curpoint" (click)="openPlanning(main.planning, $event)">
                                                <b>Personeel</b><br />
                                                @for (
                                                    userPlanning of main.planning.user_planning;
                                                    track userPlanning.id
                                                ) {
                                                    <div class="d-flex">
                                                        <div class="ellipsis">
                                                            {{ userPlanning?.user?.name }}
                                                        </div>
                                                        <div class="col-auto pl-1 pr-0">
                                                            @if (
                                                                userPlanning?.begindate | isOtherDate: this.currentDate
                                                            ) {
                                                                {{ userPlanning?.begindate | date: 'EE d MMM' }}
                                                            }
                                                            {{ userPlanning?.begindate | date: 'H:mm' }}
                                                            {{ userPlanning?.enddate | date: 'HH:mm' }}
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                            <div class="curpoint" (click)="openEquipment(main.planning)">
                                                <b>Klein materieel</b><br />
                                                @for (
                                                    phe of main.planning.planning_has
                                                        | entityType: 'visible_small' : true;
                                                    track phe
                                                ) {
                                                    <div class="d-flex">
                                                        <div class="ellipsis">
                                                            {{ phe?.entity?.name }}
                                                        </div>
                                                        <div class="col-auto pl-1 pr-0">
                                                            @if (phe?.begindate | isOtherDate: this.currentDate) {
                                                                {{ phe?.begindate | date: 'EE d MMM' }}
                                                            }
                                                            {{ phe?.begindate | date: 'H:mm' }}
                                                            {{ phe?.enddate | date: 'HH:mm' }}
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </td>
                                }
                            </tr>
                        }
                        @for (pln of main.entities; track pln; let i = $index) {
                            <tr
                                class="contents"
                                [hiringAutocompleteOptions]="hiringAutocomplete.get(pln.fg.controls.entity_id.value)"
                                [blockedMap]="blockedMap"
                                [leaveDayUserMap]="leaveDayUserMap"
                                [readOnly]="readOnly"
                                [pln]="pln.planning"
                                [fg]="pln.fg"
                                [main]="main"
                                [cdkDragDisabled]="readOnly"
                                [cdkDragData]="pln"
                                [class.highlight]="pln.highlight"
                                [class.selected]="pln.selected"
                                [highlight]="false"
                                [i]="i"
                                [drivers]="drivers"
                                [lowLoaders]="lowLoaders"
                                [employees]="employees"
                                [readonly]="readOnly"
                                [executors]="executors"
                                [startTimesEntity]="startTimesEntity"
                                [endTimesEntity]="endTimesEntity"
                                [entitiesMap]="entitiesMap"
                                [planning]="planning"
                                [currentDate]="currentDate"
                                [entityTypes]="entityTypes"
                                [hiringMap]="hiringMap"
                                [trucks]="trucks"
                                (addChooseEntity)="addChooseEntity($event)"
                                (deletePlanningEmitter)="deletePlanning($event)"
                                (duplicatePlanningEmitter)="duplicatePlanning($event)"
                                (duplicateExactEmitter)="duplicatePlanningExact($event)"
                                app-transport-planning-row
                                cdkDrag
                                cdkDragPreviewClass="cdk-drag-preview"
                                cdkDragLockAxis="y"></tr>
                        }
                        @if (!print && !readOnly) {
                            <tr class="add-row">
                                @if (!finalStatuses.includes(main.planning.status_key)) {
                                    <td colspan="15">
                                        <button
                                            class="w-100"
                                            (click)="openPlanning(main.planning, $event)"
                                            color="secondary"
                                            mat-button>
                                            Deze planning is nog niet definitief
                                        </button>
                                    </td>
                                }
                                @if (finalStatuses.includes(main.planning.status_key)) {
                                    @if (main.cutterTrucks + main.asphaltTrucks > 0) {
                                        <td colspan="8">
                                            <button class="w-100" (click)="addTrucks(main)" color="primary" mat-button>
                                                {{ main.cutterTrucks + main.asphaltTrucks }} vrachtwagens toevoegen
                                                <i class="fas fa-plus"></i>
                                            </button>
                                        </td>
                                    }
                                    <td [attr.colspan]="main.cutterTrucks + main.asphaltTrucks > 0 ? 7 : 15">
                                        <button class="w-100" (click)="addChooseType(main)" color="primary" mat-button>
                                            Regel toevoegen <i class="fas fa-plus"></i>
                                        </button>
                                    </td>
                                }
                            </tr>
                        }
                    </table>
                }
            }
        </div>
        @if (!readOnly && this.planningForms?.length > 0 && fcShowInUse.value) {
            <app-transport-in-use
                [blockedMap]="blockedMap"
                [leaveDayUserMap]="leaveDayUserMap"
                [currentDate]="currentDate">
            </app-transport-in-use>
        }
    </div>
    @if (fcShowComments.value) {
        <app-transport-planning-text></app-transport-planning-text>
    }
</div>

<ng-template #filterPerformer>
    <div class="menu performer" cdkMenu>
        <div>Selecteer {{ environment.executorName }}</div>
        <mat-selection-list class="performer-selector-dropdown" [formControl]="fcPerformerIds">
            @for (executor of executors; track executor) {
                <mat-list-option [value]="executor.id" checkboxPosition="before">
                    {{ executor.name }}
                </mat-list-option>
            }
        </mat-selection-list>
    </div>
</ng-template>
<ng-template #configMenu>
    <div class="menu" cdkMenu>
        <div>Weergave</div>
        <span class="d-block px-3">
            <mat-checkbox class="me-3" [formControl]="fcShowSmallMaterials">Pers/mat</mat-checkbox><br />
            <mat-checkbox class="me-3" [formControl]="fcShowInUse">Bezetting</mat-checkbox><br />
            <mat-checkbox [formControl]="fcShowComments">Kladblok</mat-checkbox>
        </span>
    </div>
</ng-template>
<ng-template #statusMenu>
    <div class="menu" cdkMenu>
        <div>Status</div>
        <span class="d-block px-3">
            @for (status of ['besloten', 'concept', 'definitief']; track status) {
                <mat-radio-button
                    class="w-100"
                    [checked]="fcPlanningStatus.value === status"
                    [cdkMenuItemChecked]="fcPlanningStatus.value === status"
                    (cdkMenuItemTriggered)="fcPlanningStatus.setValue(status)"
                    cdkMenuItemRadio>
                    {{ status }}
                </mat-radio-button>
            }
        </span>
    </div>
</ng-template>
